import type {
    FreeToolSharedDataRawData,
    FlashStatusType,
} from '@/Shared/AutoGenerated/Main'
import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class FreeToolSharedData {
    constructor(
        public readonly appName: string,
        public readonly currentRoute: string,
        public readonly isAuthenticated: boolean,
        public readonly flashStatus: FlashStatusType | null,
        public readonly openCookieSettingsElementId: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(rawData: FreeToolSharedDataRawData): FreeToolSharedData {
        return new FreeToolSharedData(
            rawData.appName,
            rawData.currentRoute,
            rawData.isAuthenticated,
            rawData.flashStatus,
            rawData.openCookieSettingsElementId,
        )
    }
}
